import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useUserTypeReducer = () => useSelector((state: ApplicationState) => state.userType);
